module.exports = __webpack_public_path__ + "static/media/profile-pic.454cfb7f.jpg";